import Vue from 'vue'
import firebase from "@/firebase/firebase.js"
import "firebase/firestore";
import {firestorePlugin} from 'vuefire'

Vue.use(firestorePlugin);

export const db = firebase.firestore();
//firebase.firestore.setLogLevel("debug")

//if (location.hostname === "localhost") {
//  db.useEmulator("localhost", 8081);
//}
